import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import AddressWithViewMapButton from './AddressWithViewMapButton'
import SummaryDataItem from './SummaryDataItem'

import type { Place } from 'tripPlanner/types/common'
import type { TripItem } from 'tripPlanner/types/tripItem'

const LocationAndAddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`

type Props = {
  place: Place
  placeTitle: string
  item: TripItem
}

function LocationAndAddressWithMap(props: Props) {
  const { place, placeTitle, item } = props
  return (
    <LocationAndAddressWrapper>
      <SummaryDataItem title={placeTitle} value={place.name} />
      {place.address && (
        <AddressWithViewMapButton
          item={item}
          address={place.address}
        />
      )}
    </LocationAndAddressWrapper>
  )
}
export default LocationAndAddressWithMap
